'use client';

import { c as _c } from "react/compiler-runtime";
import { Input } from '@achra/ui/input';
import { cn } from '@achra/ui/lib/utils';
import { Loader2, Search } from 'lucide-react';
import dynamic from 'next/dynamic';
import { useEffect, useRef } from 'react';
const OsCommandKeyboardShortcut = dynamic(async () => {
  const mod = await import('react-device-detect');
  return {
    default: () => <span>{mod.isMacOs ? '⌘' : 'Ctrl'}</span>
  };
}, {
  ssr: false,
  loading: () => <span>Ctrl</span> // Default fallback
});
interface SearchInputProps extends Omit<React.ComponentProps<typeof Input>, 'value' | 'onChange'> {
  value: string;
  isLoading?: boolean;
  showKeyboardShortcut?: boolean;
  onChange: (value: string) => void;
}
function SearchInput(t0) {
  const $ = _c(31);
  let className;
  let onChange;
  let props;
  let t1;
  let t2;
  let t3;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      isLoading: t1,
      onChange,
      placeholder: t2,
      showKeyboardShortcut: t3,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = onChange;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = value;
  } else {
    className = $[1];
    onChange = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    value = $[7];
  }
  const isLoading = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? "Search..." : t2;
  const showKeyboardShortcut = t3 === undefined ? true : t3;
  const inputRef = useRef(null);
  let t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const handleKeyDown = event => {
        if ((event.ctrlKey || event.metaKey) && event.key === "k") {
          event.preventDefault();
          inputRef.current?.focus();
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    };
    t5 = [];
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== className) {
    t6 = cn("bg-accent flex h-9 w-full items-center justify-between rounded-md pr-1 pl-3", className);
    $[10] = className;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isLoading) {
    t7 = <div className="h-4 w-4 shrink-0">{isLoading ? <Loader2 className="text-accent-foreground/30 h-4 w-4 animate-spin" /> : <Search className="text-accent-foreground/30 h-4 w-4" />}</div>;
    $[12] = isLoading;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== onChange) {
    t8 = e => {
      onChange(e.target.value);
    };
    $[14] = onChange;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cn("h-full flex-1 p-0", "border-0 bg-transparent shadow-none dark:bg-transparent", "placeholder:text-accent-foreground/30 text-sm", "focus-visible:ring-0 focus-visible:ring-offset-0", "[&::-webkit-search-cancel-button]:hidden [&::-webkit-search-cancel-button]:appearance-none");
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== placeholder || $[18] !== props || $[19] !== t8 || $[20] !== value) {
    t10 = <Input ref={inputRef} type="search" value={value} onChange={t8} placeholder={placeholder} className={t9} {...props} />;
    $[17] = placeholder;
    $[18] = props;
    $[19] = t8;
    $[20] = value;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t7) {
    t11 = <div className="flex h-full flex-1 items-center gap-3">{t7}{t10}</div>;
    $[22] = t10;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== showKeyboardShortcut) {
    t12 = showKeyboardShortcut && <div className="text-foreground/30 flex shrink-0 items-center gap-1 text-sm/4.5 font-medium"><div className="bg-background rounded-md border px-2 py-1"><OsCommandKeyboardShortcut /></div><div className="bg-background rounded-md border px-2 py-1"><span>K</span></div></div>;
    $[25] = showKeyboardShortcut;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12 || $[29] !== t6) {
    t13 = <div className={t6}>{t11}{t12}</div>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t6;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}
export { SearchInput };